export const checkString = (regexPattern: string, testString: string): boolean => {
  // Create a RegExp object with the provided pattern
  const pattern = new RegExp(regexPattern);

  // Use the test method to check if the string matches the pattern
  return pattern.test(testString);
};
